export default {
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //                  Trailer                     //
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//

    UI_SET_TRAILER_MOVIE:                       'UI_SET_TRAILER_MOVIE',
    UI_SET_YOUTUBE_COOKIE_CONFIRMATION:         'UI_SET_YOUTUBE_COOKIE_CONFIRMATION',

    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //                  Userbar                     //
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//

    UI_SET_ACTIVE_USER_CONTENT:                 'UI_SET_ACTIVE_USER_CONTENT',
    UI_SET_LOGGED_IN:                           'UI_SET_LOGGED_IN',

    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //                ElementDisplay                //
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    
    UI_SET_ISMOBILE:                            'UI_SET_ISMOBILE',
    UI_SET_BROWSER_WIDTH:                       'UI_SET_BROWSER_WIDTH',
    UI_TOGGLE_SIDEBARS:                         'UI_TOGGLE_SIDEBARS',
    UI_SET_ACTIVE_ITEM_INDEX:                   'UI_SET_ACTIVE_ITEM_INDEX',
    UI_SET_ACTIVE_SELECTION:                    'UI_SET_ACTIVE_SELECTION',
    UI_SET_MOVIE_DETAILS:                       'UI_SET_MOVIE_DETAILS',
    UI_SET_MOVIE_INFORMATION:                   'UI_SET_MOVIE_INFORMATION',
    UI_SET_MOVIE_PERFORMANCE_PAGE:              'UI_SET_MOVIE_PERFORMANCE_PAGE',


    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //                Connection                    //
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//

    UI_SET_IS_CONNECTED_FAST:                   'UI_SET_IS_CONNECTED_FAST',

    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    //               accessibility                  //
    //-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
    ACCESSIBILITY_SET_THEME:                    'ACCESSIBILITY_SET_THEME',


    //this is just here so I can always place a comma after the new item when adding a new one
    NONE:                                   'NONE'
};  
